import React, { useEffect, useState } from 'react';
import prodocApi, { Center, CitizenEnrollmentResult } from '../../../services/prodocApi';
import { usePageTitle } from '../../../hooks/common-hooks';
import { Button, Col, Row, Table, Tooltip } from 'antd';
import moment from 'moment';
import { DATE_TIME_FORMAT } from '../../../constants/common';
import { LogoutOutlined, MedicineBoxOutlined, PlusOutlined } from '@ant-design/icons';
import { useHistory } from 'react-router';
import { ROUTES } from '../../../constants/routes';
import CitizenDischargeForm from '../../../components/citizen/CitizenDischargeForm/CitizenDischargeForm';
import { dischargeCitizen } from '../../../store/citizenStore';
import { useDispatch } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBullseye } from '@fortawesome/free-solid-svg-icons';
import { ColumnType } from 'antd/es/table';

export function CenterOverviewPage() {
  //getManyByCenter
  const [centers, setCenters] = useState<Center[]>();
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();

  usePageTitle('Centre');

  useEffect(() => {
    GetEnrollments();
  }, []);
  async function GetEnrollments() {
    try {
      setIsLoading(true);
      const result = await prodocApi.center.getMyCenters();
      setCenters(result);
    } finally {
      setIsLoading(false);
    }
  }
  async function showHealthCitizen(e, citizenEnrollment: CitizenEnrollmentResult) {
    e.stopPropagation();
    history.push(ROUTES.MEDICINE_HEALTH.replace(':citizenEnrollmentId?', citizenEnrollment.id));
  }
  async function showGoalCitizen(e, citizenEnrollment: CitizenEnrollmentResult) {
    e.stopPropagation();
    history.push(ROUTES.GOALS.replace(':citizenEnrollmentId?', citizenEnrollment.id));
  }

  const columns: ColumnType<Center>[] = [
    {
      title: 'Center',
      render: (o: Center) => o.name,
      key: 'name',
      sorter: (a, b) => a.name.localeCompare(b.name),
    },
    {
      title: 'Adresse',
      dataIndex: 'address',
      key: 'address',
      sorter: (a, b) => (a.address || '').localeCompare(b.address || ''),
    },
    {
      title: 'Postnummer',
      dataIndex: 'zipCode',
      key: 'zipCode',
      sorter: (a, b) => (a.zipCode || '').localeCompare(b.zipCode || ''),
    },
    {
      title: 'By',
      dataIndex: 'city',
      key: 'city',
      sorter: (a, b) => (a.city || '').localeCompare(b.city || ''),
    },
    {
      title: 'Oprettet',
      dataIndex: 'createdOn',
      render: date => (date ? moment(date).format(DATE_TIME_FORMAT) : ''),
      sorter: (a, b) => Date.parse(a.createdOn.toString()) - Date.parse(b.createdOn.toString()),
    },
  ];
  function handleRowClicked(e) {
    history.push(ROUTES.CENTER_DETAILS.replace(':id?', e.id));
  }
  function handleCreateCenter() {
    history.push(ROUTES.CENTER_ADD);
  }
  function handleDischarge(date: Date, cause: string, citizenEnrollmentId: string) {
    dispatch(dischargeCitizen({ date, cause, citizenEnrollmentId }));

    GetEnrollments();
  }
  return (
    <div className="citizen-page page-full">
      <Row>
        <Col span={24}>
          <div style={{ background: '#fafafa', padding: '8px' }}>
            <Tooltip title="Opret center">
              <Button shape="circle" icon={<PlusOutlined translate="" />} onClick={handleCreateCenter} />
            </Tooltip>
          </div>
          <Table
            style={{ cursor: 'pointer' }}
            loading={isLoading}
            pagination={{ pageSize: 15 }}
            dataSource={centers}
            onRow={(record, rowIndex) => {
              return {
                onClick: () => handleRowClicked(record),
              };
            }}
            columns={columns}
            rowKey="id"
          />
        </Col>
      </Row>
    </div>
  );
}
